// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__32eW3","title":"Images45_title__38yJs","images":"Images45_images__12Gci"};